module.exports = __webpack_public_path__ + "assets/nodejs.740b3505.svg";